import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-bar',
  templateUrl: './breadcrumb-bar.component.html',
  styleUrl: './breadcrumb-bar.component.scss'
})
export class BreadcrumbBarComponent {
  @Input() title: string = '';
  @Input() homeLink: string = '/home/landing';
  @Input() parentTitle: string = '';
  @Input() parentLink: string = '';
}
